import React from 'react';
import './style/index.css';
import App from './App';
import { ConfigProvider } from 'antd';
import ReactDOM from 'react-dom/client';
import ruRU from 'antd/locale/ru_RU';
import dayjs from 'dayjs'
import 'dayjs/locale/ru'
dayjs.locale('ru')
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ConfigProvider locale={ruRU}
      theme={{
        components: {
          Layout: {
            // headerBg: '#f5f5f5',
            siderBg: '#FFF',
            headerBg: '#FFF',
            bodyBg: '#FFF'

          },
          Menu: {
            itemActiveBg: "#DEC9FF80",
            itemSelectedBg: "#DEC9FF80",

          },
          Collapse: {
            colorBorder: 'none',
            contentBg: '#DEC9FFFF',
            headerBg: 'rgba(0, 0, 0, 0)'
          },
          Tabs: {
            // itemActiveColor: "#000",
            // cardBg: '#7433D6'
            colorBgContainer: '#7433D6',
            itemActiveColor: '#FFFFFF',
            itemSelectedColor: '#FFFFFF'
          },
          Radio: {
            buttonSolidCheckedHoverBg: '#7433D6',
            buttonSolidCheckedBg: '#7433D6'

          },
          Tree: {
            colorBgContainer: "#0000000",
            colorPrimary: "#7433D6",
            colorBorder: "#7433D6"
          },
          colorBgContainer1: "#DEC9FF80"
          // Typography: {
          //   Title: {
          //     colorText: '#CCC'
          //   }
          // }
        }
      }}>
      <App />
    </ConfigProvider>
  </React.StrictMode>
);